import { useSnapshot } from 'valtio';

import { FormLoginWithOtp } from '../../components/pages/auth/forms/form-login-w-otp.jsx';
import { FormLoginWithPassword } from '../../components/pages/auth/forms/form-login-w-password.jsx';
import PortalHeading from '../../components/pages/customer-portal/heading.jsx';
import { Card } from '../../components/ui/card.jsx';
import { loginState, loginType } from '../../services/state/login-state.jsx';

export const Login = () => {
  const snapLoginState = useSnapshot(loginState);
  // <Card className="rounded-lg bg-portal-background p-8 sm:rounded-[40px] md:p-12">

  return (
    <Card className="p-4 sm:p-10">
      <div className="flex flex-col space-y-2 pb-4 text-left">
        <PortalHeading className="!text-xl">Iniciar sessão</PortalHeading>
        <p className="text-sm text-muted-foreground">
          {snapLoginState.type === loginType.password
            ? 'Insira os dados da sua conta'
            : 'Insira o email associado à sua conta e o código único de acesso que receberá no seu email'}
        </p>
      </div>

      <div className="grid">
        {snapLoginState.type === loginType.password ? (
          <FormLoginWithPassword />
        ) : (
          <FormLoginWithOtp />
        )}
      </div>
    </Card>
  );
};
